import { Pipe, PipeTransform } from '@angular/core';
import { TextUtils, CapitalizeMode } from './text-utils';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {

  transform(value: string, type: CapitalizeMode = 'first'): string {
    return TextUtils.capitalize(value, type);
  }

}